/**
 * Dashboard KPI + chart data (approved contract: docs/API_CONTRACT.md).
 * Components only depend on the resolved `{ data, meta }` shape; the numbers themselves come from
 * the backend (in mock mode they are computed from the live conversation and lead stores).
 */
import { ApiError } from './apiError';
import { validateRange, validatePayload } from './validators';
import { apiClient } from './apiClient';

export const ENDPOINTS = {
  visitors: '/api/dashboard/kpis/visitors',
  conversations: '/api/dashboard/kpis/conversations',
  leads: '/api/dashboard/kpis/leads',
  conversionRate: '/api/dashboard/kpis/conversion-rate',
  aiResponse: '/api/dashboard/kpis/ai-response',
  escalationRate: '/api/dashboard/kpis/escalation-rate',
  responseTime: '/api/dashboard/kpis/response-time',
  aiUsage: '/api/dashboard/kpis/ai-usage',
  engagementTrend: '/api/dashboard/charts/engagement-trend',
  supportResolution: '/api/dashboard/charts/support-resolution',
  ctaPerformance: '/api/dashboard/charts/cta-performance',
};

// scenario is a QA/preview switch from the top bar: live | loading | empty | error
export async function fetchMetric(key, { range = 'today', scenario = 'live' } = {}) {
  validateRange(range);
  if (!ENDPOINTS[key]) throw new ApiError(404, 'NOT_FOUND', `Unknown metric "${key}"`);

  if (scenario === 'loading') return new Promise(() => {}); // never resolves
  const mock = scenario === 'empty' || scenario === 'error' ? `&mock=${scenario}` : '';
  let response;
  try {
    response = await apiClient(`${ENDPOINTS[key]}?range=${range}${mock}`);
  } catch (error) {
    throw new ApiError(error.status || 500, error.code || 'SERVER_ERROR', error.message || 'Something went wrong on our side.');
  }
  validatePayload(key, response.data);
  return { data: response.data, meta: { ...response.meta, endpoint: ENDPOINTS[key] } };
}
